import $ from "jquery";
import * as bootstrap from "bootstrap";
import api from "./ajax";
import renderJobHistory from "./render-job-history";

const sendTo = [];

const addSendTo = (subcontractor) => {
	sendTo.push(subcontractor);
}

const removeSendTo = (key, value) => {
	const index = sendTo.findIndex((element) => {
		return element[key] === value;
	})
	sendTo.splice(index, 1);
}


const sendMessage = () => {
	// On send message modal close - clear the textarea
	const sendMessageModal = document.getElementById('sendMessageModal');
	// const sendTo = [];

	// Reset on modal close
	if (sendMessageModal) {
		sendMessageModal.addEventListener('hide.bs.modal',  (event) => {
			const {currentTarget} = event;
			const textarea = $(currentTarget).find('textarea');
			const input = $(currentTarget).find('input');

			textarea.val('');
			input.val('');
		});
	}

	$('#sendMessage').on('click', async (e) => {
		const { currentTarget } = e;
		const sendButton = $(currentTarget);
		const modalBody = sendButton.parents('.modal__body');
		const jobId = $('#subContractorsTable').data('job-id') ? $('#subContractorsTable').data('job-id') : false;
		const jobHistoryList = $('#jobHistoryList');
		// const sendTo = $('#subContractorsTable .send-to-driver:checked').get().map(e => {
		//     return $(e).val();
		// });

		const message = $('#textMessageBody').val();
		let modal = document.getElementById('sendMessageModal');

		modal = bootstrap.Modal.getInstance(modal);
		modalBody.children('.sending').addClass('show');

		const response = await api.sendMessage(sendTo, message, jobId, this);

		if (response.error) {
			return;
		}

		// Update the Job History
		if (jobId) {
			const jobHistory = await api.getJobHistory(jobId, this);

			if (jobHistory.error) {
				return;
			}

			const jobHistoryHtml = renderJobHistory(jobHistory.body);

			// Build HTML for job history items and then replace html in history list
			jobHistoryList.html(jobHistoryHtml);
		}

		modal.hide();
		modalBody.children('.sending').removeClass('show');
	});


};

export default sendMessage;
export {addSendTo, removeSendTo};